"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const throttle_debounce_1 = require("throttle-debounce");
const _1 = require("../.");
/**
 * A basic input field.
 */
const Input = (_a) => {
    var { name, type = 'text', value = '', placeholder, min, debounceTime = 500, accept, activateEnterPress, mandatory, setValue } = _a, otherProps = __rest(_a, ["name", "type", "value", "placeholder", "min", "debounceTime", "accept", "activateEnterPress", "mandatory", "setValue"]);
    const [internalValue, setInternalValue] = react_1.default.useState('');
    // Apply initial value and react on initialValue change.
    react_1.default.useEffect(() => {
        if (value !== internalValue) {
            setInternalValue(value);
        }
    }, [value]);
    const handleSetValue = (val) => {
        if (val !== value) {
            setValue(name, val, mandatory, { touched: true, type, min });
        }
    };
    const debouncedSetValue = react_1.default.useCallback((0, throttle_debounce_1.debounce)(debounceTime, nextValue => handleSetValue(nextValue)), []);
    return (react_1.default.createElement("input", Object.assign({ className: 'rfc-input', name: name, type: type === 'password-novalidation' ? 'password' : type, 
        // This allows to add a custom validation rule for password field, while still
        // being able to skip the check where it is not neccessary, eg. on login forms.
        placeholder: placeholder, onChange: (e) => {
            var _a;
            if (type === 'file' && ((_a = e.target.files) === null || _a === void 0 ? void 0 : _a.length)) {
                const fileReader = new FileReader();
                const dataFile = e.target.files[0];
                const { name: fileName, type: fileType } = dataFile;
                fileReader.readAsDataURL(e.target.files[0]);
                fileReader.onload = () => {
                    const data = fileReader.result;
                    setValue(name, {
                        name: fileName,
                        type: fileType.split('/')[0],
                        data,
                        dataFile,
                    }, mandatory, { touched: true });
                };
            }
            else {
                setInternalValue(e.target.value);
                debouncedSetValue(e.target.value);
            }
        }, onKeyPress: (e) => {
            if (activateEnterPress && e.code === 'Enter') {
                e.preventDefault();
                setValue(name, internalValue, mandatory, { type, min, forceSubmit: true });
            }
        }, accept: accept, value: type !== 'file' ? internalValue : undefined, onBlur: e => handleSetValue(e.target.value) }, otherProps)));
};
exports.default = (0, _1.withFormControl)(Input);
